module.exports = __webpack_public_path__ + "static/media/identity.11919571.svg";